import { RouterModule, Routes, ExtraOptions } from '@angular/router';
import { NgModule } from '@angular/core';

import { PagesComponent } from './pages.component';
import { InputComponent } from './../pages/input/input.component';
import { BotonesComponent } from './../pages/botones/botones.component';
import { InicioComponent } from './../pages/inicio/inicio.component';
import { IconosComponent } from './../pages/iconos/iconos.component';
import { CarouselComponent } from './../pages/carousel/carousel.component';
import { CheckboxComponent } from './../pages/checkbox/checkbox.component';
import { DesplegablesComponent } from './../pages/desplegables/desplegables.component';
import { EtiquetasComponent } from './../pages/etiquetas/etiquetas.component';
import { FormularioComponent } from './../pages/formulario/formulario.component';
import { BreadcrumbComponent } from './../pages/breadcrumb/breadcrumb.component';
import { ModalDocComponent } from './modal-doc/modal-doc.component';
import { NotificacionesComponent } from './../pages/notificaciones/notificaciones.component';
import { PaginacionComponent } from './../pages/paginacion/paginacion.component';
import { RadiobuttonsComponent } from './../pages/radiobuttons/radiobuttons.component';
import { TablaComponent } from './../pages/tabla/tabla.component';
import { ScrollComponent } from './../pages/scroll/scroll.component';
import { CollapseComponent } from './../pages/collapse/collapse.component';
import { TecladoComponent } from './../pages/teclado/teclado.component';
import { TextareaComponent } from './../pages/textarea/textarea.component';
import { TooltipComponent } from './../pages/tooltip/tooltip.component';
import { AlertasComponent } from './../pages/alertas/alertas.component';
import { TabsComponent } from './../pages/tabs/tabs.component';
import { HeaderDocComponent } from './header-doc/header-doc.component';
import { FooterDocComponent } from './footer-doc/footer-doc.component';
import { BarraAccesibilidadDocComponent } from './barra-accesibilidad-doc/barra-accesibilidad-doc.component';
import { ColoresComponent } from './colores/colores.component';
import { TipografiaComponent } from './tipografia/tipografia.component';
import { BackToTopDocComponent } from './back-to-top-doc/back-to-top-doc.component';
import { CalendarioComponent } from './calendario/calendario.component';
import { InicioSesionComponent } from './inicio-sesion/inicio-sesion.component';
import { ContadorComponent } from './contador/contador.component';
import { EmbebidosComponent } from './embebidos/embebidos.component';
import { CardsComponent } from './cards/cards.component';
import { EspaciadosComponent } from './espaciados/espaciados.component';
import { VisualizacionArchivosComponent } from './visualizacion-archivos/visualizacion-archivos.component';
import { ContenedorImagenesComponent } from './contenedor-imagenes/contenedor-imagenes.component';
import { ImplementationComponent } from './transversales/implementation/implementation.component';
import { InputFileComponent } from './input-file/input-file.component';

const routes: Routes = [{
    path: '',
    component: PagesComponent,
    children: [
        { path: 'pages/inicio', component: InicioComponent, pathMatch: 'full' },
        { path: 'pages/alertas', component: AlertasComponent, pathMatch: 'full' },
        { path: 'pages/botones', component: BotonesComponent, pathMatch: 'full' },
        { path: 'pages/input', component: InputComponent, pathMatch: 'full' },
        { path: 'pages/iconos', component: IconosComponent, pathMatch: 'full' },
        { path: 'pages/carousel', component: CarouselComponent, pathMatch: 'full' },
        { path: 'pages/checkbox', component: CheckboxComponent, pathMatch: 'full' },
        { path: 'pages/desplegables', component: DesplegablesComponent, pathMatch: 'full' },
        { path: 'pages/etiquetas', component: EtiquetasComponent, pathMatch: 'full' },
        { path: 'pages/formulario', component: FormularioComponent, pathMatch: 'full' },
        { path: 'pages/breadcrumb', component: BreadcrumbComponent, pathMatch: 'full' },
        { path: 'pages/modal-doc', component: ModalDocComponent, pathMatch: 'full' },
        { path: 'pages/notificaciones', component: NotificacionesComponent, pathMatch: 'full' },
        { path: 'pages/paginacion', component: PaginacionComponent, pathMatch: 'full' },
        { path: 'pages/radio', component: RadiobuttonsComponent, pathMatch: 'full' },
        { path: 'pages/tabla', component: TablaComponent, pathMatch: 'full' },
        { path: 'pages/scroll', component: ScrollComponent, pathMatch: 'full' },
        { path: 'pages/tabs', component: TabsComponent, pathMatch: 'full' },
        { path: 'pages/collapse', component: CollapseComponent, pathMatch: 'full' },
        { path: 'pages/teclado', component: TecladoComponent, pathMatch: 'full' },
        { path: 'pages/textarea', component: TextareaComponent, pathMatch: 'full' },
        { path: 'pages/tooltip', component: TooltipComponent, pathMatch: 'full' },
        { path: 'pages/header', component: HeaderDocComponent, pathMatch: 'full' },
        { path: 'pages/footer', component: FooterDocComponent, pathMatch: 'full' },
        { path: 'pages/colores', component: ColoresComponent, pathMatch: 'full' },
        { path: 'pages/barraAccesibilidad', component: BarraAccesibilidadDocComponent, pathMatch: 'full' },
        { path: 'pages/backToTopDoc', component: BackToTopDocComponent, pathMatch: 'full' },
        { path: 'pages/calendario', component: CalendarioComponent, pathMatch: 'full' },
        { path: 'pages/inicioSesion', component: InicioSesionComponent, pathMatch: 'full' },
        { path: 'pages/contador', component: ContadorComponent, pathMatch: 'full' },
        { path: 'pages/embebidos', component: EmbebidosComponent, pathMatch: 'full' },
        { path: 'pages/cards', component: CardsComponent, pathMatch: 'full' },
        { path: 'pages/espaciados', component: EspaciadosComponent, pathMatch: 'full' },
        { path: 'pages/visualizacionArchivos', component: VisualizacionArchivosComponent, pathMatch: 'full' },
        { path: 'pages/contenedorImagenes', component: ContenedorImagenesComponent, pathMatch: 'full' },
        { path: 'pages/tipografia', component: TipografiaComponent, pathMatch: 'full' },
        { path: 'pages/implementacion', component: ImplementationComponent, pathMatch: 'full' },
        { path: 'pages/file', component: InputFileComponent, pathMatch: 'full' },
        { path: '', redirectTo: 'pages/inicio', pathMatch: 'full' },
    ],
}];

const routerOptions: ExtraOptions = {
    useHash: false,
    scrollPositionRestoration: 'enabled',
    anchorScrolling: 'enabled',
    scrollOffset: [0, 64]
};

@NgModule({
    imports: [RouterModule.forRoot(routes, routerOptions)],
    exports: [RouterModule]
})
export class PagesRoutingModule {
}

